import { useEffect, useRef } from 'react';

import { useRouter } from '@tanstack/react-router';

import { useAuthStore } from './auth-store';

/**
 * SCRUM-102 Phase A — the SPA-side landing for the bank IdP redirect
 * (/auth/callback). Completes the sign-in by handing the authorization code to
 * the backend for the server-side exchange (plan D1). On completion it
 * invalidates the router so the auth-context guards re-run: success routes the
 * user on to their landing (via the index redirect), failure lands them on
 * /login with the store's error. (SCRUM-616 — now a real route.)
 */
export function AuthCallbackPage() {
  const completeSsoCallback = useAuthStore((s) => s.completeSsoCallback);
  const router = useRouter();
  const started = useRef(false);

  useEffect(() => {
    // The exchange consumes a SINGLE-USE code — guard against StrictMode's
    // double-invoked effects re-posting it.
    if (started.current) return;
    started.current = true;

    void completeSsoCallback(window.location.href).finally(() => {
      // Replace the callback URL (with its ?code&state) so it leaves no history
      // entry, then re-run the route guards against the now-updated auth store:
      // authenticated -> index redirect to the role landing; failed -> /login.
      void router.navigate({ to: '/', replace: true }).then(() => {
        void router.invalidate();
      });
    });
  }, [completeSsoCallback, router]);

  return (
    <div className="bg-bg-1 flex h-screen items-center justify-center">
      <p className="text-text-2 text-sm">Completing sign-in…</p>
    </div>
  );
}
